import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import { CC3APIModel } from '../cc3-model';
import { CC3ConfigAPIModel } from './cc3-config-model';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;
@Component({
  selector: 'app-cc3-config',
  templateUrl: './cc3-config.component.html',
  styleUrls: ['./cc3-config.component.css']
})
export class CC3ConfigComponent implements OnInit {
  modelItem = new CC3ConfigAPIModel();


  dataTableConfig: any;
  @ViewChild('dataTableConfig', { static: false }) tableConfig;
  dataSetConfig: any;

  popupButtonText: string;
  popupConfigButtonText: string = "Save";
  ConfigModalButton: string = "Submit";
  title: string;
  titles: string;
  journalList: any;
  PublisherList: any;
  showConfigModal: boolean;
  journalListConfig: any;


  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <CC3ConfigAPIModel>data["CC3ConfigPage"];

        this.GetConfigList();
        this.GetJournalsdetails();
        this.GetPublisherID();
        this.GetConfigJournalsdetails();
        localStorage.trId = 0;
        $("#ddlConfigPublisher").select2({
          placeholder: "Select Publisher", dropdownParent: "#divPopupartBody"
        });
        $("#ddlConfigJournal").select2({
          placeholder: "Select Journal", dropdownParent: "#divPopupartBody"
        });

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  ngAfterViewChecked(): void {
    $('.tblRightsList').css('height', GlobalConstants.size.height - 250);
  }
  GetJournalsdetails(): void {
    ApiMethod.getMethod(this.modelItem.GetjournalsListApi + localStorage.aPubID).subscribe(
      result => {
        this.journalList = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get PublisherId
  GetPublisherID(): void {
    ApiMethod.getMethod(this.modelItem.PublisherIDAPI).subscribe(
      result => {
        this.PublisherList = result.aPublisherID;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetConfigJournalsdetails(): void {
    let pubId = $('#ddlConfigPublisher').val();
    ApiMethod.getMethod(this.modelItem.GetConfigjournalsListApi + pubId).subscribe(
      result => {
        this.journalListConfig = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetConfigList() {
    var ConfigData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "CC3ConfigModule",
    };
    ApiMethod.postMethod(this.modelItem.ConfigGridAPI, ConfigData).subscribe(
      result => {

        this.dataSetConfig = JSON.stringify(result.aitemList); // Data List
        this.dataSetConfig = JSON.parse(this.dataSetConfig);
        this.dataTableConfig = $(this.tableConfig.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = "btnConfigAddNew";
        dataItem.dataTable = this.dataTableConfig;
        dataItem.dataset = this.dataSetConfig;
        dataItem.dtheight = (GlobalConstants.size.height - 180);
        dataItem.modulename = 'CC3ConfigModule';
        dataItem.isDefault = false;
        dataItem.colsetting = false;
        this.dataTableConfig = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  ShowConfigList() {
    $("#btnPopupartDetail").show();
    this.ClearData();
    $("#tblAddCC3Config tbody").html("");
    if (localStorage.aEID != 0) {
      $("#LoadingImagePopupConfig").show();
      ApiMethod.getMethod(this.modelItem.CC3ConfigByID + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopupConfig").hide();
          let aitems = result.aitemList;
          $('#txtFormulaName').val(aitems[0].FormulaName);
          $("#ddlConfigPublisher").val(aitems[0].PublisherId).change();
          $("#ddlConfigJournal").val(aitems[0].Acronym).change();
          $('#TxtWordsDivision').val(aitems[0].WordsDivision);
          $('#txtRemarks').val(aitems[0].Remarks);

          // Show the HTML table from ShowConfigCategory()


          ApiMethod.getMethod(this.modelItem.GetCategoryTableId + '/' + localStorage.aEID).subscribe(
            Response => {
              let aitems = Response.aitemList;
              console.log(aitems);
              //if (aitems.length <= 0) {
              //  ngswal("Failed !", "Category Data History Not Available", "error");
              //  return;
              //}
              $("#ddlCategory").val(aitems[0].Category).change();
              $("#ddlApplicabaleSummary").val(aitems[0].ApplicableSummary);
              $('#ddlWeightage').val(aitems[0].Division).change();
              $('#txt_Remarks').val(aitems[0].Remarks);

              let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
              let styleDelete = styleEdit.replace("#34c38f;", "#f46a6a;");
              if (aitems.length != 0) {
                var nRowL = "";
                for (var i = 0; i < aitems.length; i++) {
                  let _applicableSummary = aitems[i].ApplicableSummary == true ? 'Yes' : 'No';
                  nRowL += "<tr id='trId_" + (i + 1).toString() + "'>";
                  nRowL += "<td>" + (i + 1).toString() + "</td>";
                  nRowL += "<td  style='display:none'>" + GlobalConstants.isNullCheck(aitems[i].Id) + "</td>";
                  nRowL += "<td>" + GlobalConstants.isNullCheck(aitems[i].Category) + "</td>";
                  nRowL += "<td>" + _applicableSummary + "</td>";
                  nRowL += "<td>" + (100 / aitems[i].Division) + "%</td>";
                  nRowL += "<td>" + GlobalConstants.isNullCheck(aitems[i].Remarks) + "</td>";
                  nRowL += "<td style='text-align: center'>"
                    + "<i class='bx bxs-edit-alt' title='Edit' " + styleEdit + " onclick=localStorage.trId='" + (i + 1).toString() + "';$('#spUpdateConfig').trigger('click');></i>&nbsp;"
                    + "<i class='bx bxs-trash' title='Delete' " + styleDelete + " onclick=localStorage.trId='" + (i + 1).toString() + "';$('#btnDeleteCategory').trigger('click');></i>&nbsp;"
                    + "</td>";
                  nRowL += "</tr>";
                }
                $("#tblAddCC3Config tbody").append(nRowL);
              }
            },
            error => {
              $("#LoadingImagePopupConfig").hide();
              ngswal("Failed !", error.message, "error");
            }
          );

        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.popupConfigButtonText = "Update";
    } else this.popupConfigButtonText = "Save";
    this.title = " Config Details";
  }

  addUpdateConfig() {

    var getConfigList = []; getConfigList = GlobalConstants.GetTableRowToList('tblAddCC3Config', null, true);
    console.log(getConfigList);
    for (var i = 0; i < getConfigList.length; i++) {
      getConfigList[i] = getConfigList[i].toString();
    }


    if ($('#txtFormulaName').val().trim() == '') {
      ngswal("Warning !", "Please Enter Formula Name !", "warning");
    }
    else if ($('#ddlConfigPublisher').val() == 0) {
      ngswal("Warning !", "Please Select Publisher !", "warning");
    }
    else if ($('#TxtWordsDivision').val() == '') {
      ngswal("Warning !", "Please Enter Words Division !", "warning");
    }
    else if (getConfigList.length == 0) {
      ngswal("Warning !", "Please Add Category details !", "warning");
    }
    else {
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      $("#LoadingImagePopup").show();
      var ConfigData =
      {
        Id: localStorage.aEID,
        FormulaName: $("#txtFormulaName").val(),
        PublisherId: $("#ddlConfigPublisher").val().toString(),
        JournalId: $("#ddlConfigJournal").val().toString(),
        WordsDivision: $("#TxtWordsDivision").val(),
        Remarks: $("#txtRemarks").val(),
        Category: $("#ddlCategory").val(),
        ApplicableSummary: $("#ddlApplicabaleSummary").val(),
        Division: $("#ddlWeightage").val(),
        ConfigCategory: getConfigList,
        UpdatedBy: localStorage.aLoginID
      };

      ApiMethod.postMethod(this.modelItem.UpdateConfigAPI, ConfigData).subscribe(
        resonse => {
          $("#LoadingImagePopupConfig").hide();
          ngswal("info!", resonse.aresultL, "info");
          this.GetConfigList();
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopupConfig").hide();
        }
      );
    }
  }

  hideConfig() {
    $("#btnPopupartDetail").hide();
  }

  CategoryDuplicate(): boolean {
    let validate = true;
    let _categoryName = $('#ddlCategory').val();
    var getConfigList = [];
    getConfigList = GlobalConstants.GetTableRowToList('tblAddCC3Config', null, true);
    for (var i = 0; i < getConfigList.length; i++) {
      if (GlobalConstants.isNaNCheck(localStorage.trId) != (i + 1)) {
        var configName = getConfigList[i][2]; // Access the current item in the loop
        if (_categoryName == configName) {
          ngswal("warning", _categoryName + " is repeated.", "warning");
          validate = false;

        }
      }
    }
    return validate;
  }

  UpdateConfigCategoryData() {
    let checkDuplicate = this.CategoryDuplicate();
    if (checkDuplicate) {
      if ($('#ddlCategory').val() == 'Select') {
        ngswal("Warning !", "Please Select Category!", "warning");
      }
      else if ($('#ddlWeightage').val() == '0') {
        ngswal("Warning !", "Please Select Weightage!", "warning");
      }
      else {

        this.showConfigModal = true;
        var zRowLength = $("#tblAddCC3Config").find("tr").length;
        let _appsummary = ($('#ddlApplicabaleSummary').val() == 'true' ? 'Yes' : 'No');
        if (localStorage.trId == 0) {

          let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
          let styleDelete = styleEdit.replace("#34c38f;", "#f46a6a;");

          $("#tblAddCC3Config tbody").append(
            "<tr id='trId_" + zRowLength.toString() + "'>" +
            "<td>" + zRowLength.toString() + "</td>" +
            "<td style='display:none'>0</td>" +
            "<td>" + $("#ddlCategory").val() + "</td>" +
            "<td>" + _appsummary + "</td>" +
            "<td>" + (100 / $("#ddlWeightage").val()) + "%</td>" +
            "<td>" + $("#txt_Remarks").val() + "</td>"
            + "<td style='text-align: center'>"
            + "<i class='bx bxs-edit-alt' title='Edit' " + styleEdit + " onclick=localStorage.trId='" + zRowLength.toString() + "';$('#spUpdateConfig').trigger('click');></i>&nbsp;"
            + "<i class='bx bxs-trash' title='Delete' " + styleDelete + " onclick=localStorage.trId='" + zRowLength.toString() + "';$('#btnDeleteCategory').trigger('click');></i>&nbsp;"
            + "</td>"
            + "</tr>"
          );

        }
        else {
          let trId = '#trId_' + localStorage.trId;
          $(trId).find('td')[1].outerHTML = "<td style='display:none'>" + $(trId).find('td')[1].innerHTML + "</td>";
          $(trId).find('td')[2].outerHTML = "<td>" + $("#ddlCategory").val() + "</td>";
          $(trId).find('td')[3].outerHTML = "<td>" + _appsummary + "</td>";
          $(trId).find('td')[4].outerHTML = "<td>" + (100 / $("#ddlWeightage").val()) + "%</td>";
          $(trId).find('td')[5].outerHTML = "<td>" + $("#txt_Remarks").val() + "</td>";
        }
        this.hideCategory();
      }
    }
  }

  ShowConfigCategory(id = 0) {

    this.titles = "Config Category Details";
    this.showConfigModal = true;
    if (localStorage.trId == 0) {
      this.clearCategory();
    }
    else {
      let trId = '#trId_' + localStorage.trId;
      $("#ddlCategory").val($(trId).find('td')[2].innerHTML);
      $("#ddlApplicabaleSummary").val($(trId).find('td')[3].innerHTML == 'Yes' ? 'true' : 'false').change();
      $("#ddlWeightage").val($(trId).find('td')[4].innerHTML == '100%' ? 1 : 2).change();
      $("#txt_Remarks").val($(trId).find('td')[5].innerHTML);
    }
  }

  deleteConfigCategory() {
    ngswal({
      title: "Confirmation !",
      text: "Are you sure to remove ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Remove!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $("#trId_" + localStorage.trId).closest("tr").remove();
          $("table#tblAddCC3Config tbody").each(function () {
            $(this).children().each(function (index) {
              $(this).find("td").first().html((index + 1).toString());
            });
          });
          ngswal("Removed !", "Removed successfully :)", "info");
        } else {
          ngswal("Cancelled !", "You clicked cancel! :)", "warning");
        }
      });



  }

  hideCategory() {
    this.showConfigModal = false;
    this.clearCategory();
    localStorage.trId = 0;
  }

  clearCategory() {
    $('#ddlCategory').val('Select').change();
    $("#myModalConfig input[type='text']").val("");
    $("#myModalConfig input[type='number']").val("");
    $("#ddlApplicabaleSummary").val('true').change();

  }

  ClearData(): void {
    $("#ddlJournalList").val(0).change();
    $("#Levelconfig").val(0).change();
    $("#Scorelevel").val(0).change();
    $("input[type='text']").val("");
    $("input[type='number']").val("");
  }

  hide(): void {


  }

}
